var _rect, _ellipse, _path, _ellipse2, _ellipse3, _ellipse4, _rect2, _rect3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 668,
    height: 401,
    viewBox: "0 0 668 401",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Credit card",
    filter: "url(#filter0_d_41_588)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41_588)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.363922,
    width: 667.727,
    height: 400.636,
    rx: 38.1558,
    fill: "#111827"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse",
    cx: 511.528,
    cy: 168.491,
    rx: 159.796,
    ry: 249.172,
    transform: "rotate(-45 511.528 168.491)",
    fill: "#A855F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_2",
    opacity: 0.5,
    d: "M112.83 47.0286C58.3348 21.0415 4.05818 10.4675 -42.6292 16.7426C-89.3166 23.0176 -126.152 45.8376 -148.134 82.1036C-170.116 118.37 -176.178 166.324 -165.498 219.455C-154.818 272.586 -127.912 328.318 -88.436 379.083C-48.9596 429.848 1.17499 473.187 55.1595 503.213C109.144 533.238 164.362 548.497 213.316 546.916C262.269 545.334 302.585 526.99 328.789 494.374C354.993 461.758 365.815 416.451 359.786 364.606L95.3889 281.004L112.83 47.0286Z",
    fill: "#A855F7"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3",
    cx: 402.925,
    cy: 28.8858,
    rx: 92.3488,
    ry: 143.863,
    transform: "rotate(-45 402.925 28.8858)",
    fill: "#2DD4BF",
    fillOpacity: 0.8
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4",
    cx: 0.00125353,
    cy: 343.766,
    rx: 92.3488,
    ry: 143.863,
    transform: "rotate(-45 0.00125353 343.766)",
    fill: "#2DD4BF",
    fillOpacity: 0.64
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_5",
    cx: 582.735,
    cy: 278.718,
    rx: 154.354,
    ry: 148.824,
    transform: "rotate(-45 582.735 278.718)",
    fill: "#2DD4BF"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -114.467,
    y: -113.299,
    width: 896.661,
    height: 629.571
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(57.23px)",
      clipPath: "url(#bgblur_1_41_588_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Background Blur",
    "data-figma-bg-blur-radius": 114.467,
    y: 1.16843,
    width: 667.727,
    height: 400.636,
    fill: "#1E2E65",
    fillOpacity: 0.4
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.19237,
    y: 1.55629,
    width: 665.342,
    height: 398.251,
    rx: 36.9634,
    stroke: "#374151",
    strokeWidth: 2.38474
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_41_588",
    x: -57.2337,
    y: -47.3308,
    width: 782.194,
    height: 515.104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.53895
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 28.6169
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_41_588"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_41_588",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_41_588_clip_path",
    transform: "translate(114.467 113.299)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 1.16843,
    width: 667.727,
    height: 400.636
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41_588"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.363922,
    width: 667.727,
    height: 400.636,
    rx: 38.1558,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardBg);
export default __webpack_public_path__ + "static/media/card-bg.20d672607b1c7e23d63cd9411d2dbe5a.svg";
export { ForwardRef as ReactComponent };